import ContextMenu from './contextMenu.view';

export default ContextMenu;
